import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import * as moment from 'moment';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import { ViewSettlementPaymentsComponent } from '../../userflow/view-settlement-payments/view-settlement-payments.component';
import { UserNewPaymentComponent } from '../user-new-payment/user-new-payment.component';
import { ColumnApi, GridApi } from 'ag-grid-community';

@Component({
  selector: 'app-user-new-settlement',
  templateUrl: './user-new-settlement.component.html',
  styleUrls: ['./user-new-settlement.component.css']
})
export class UserNewSettlementComponent implements OnInit {
  private gridApi: GridApi;
  private columnApi: ColumnApi;
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  SettlementcolumnDefs = [
    {headerName: 'Customer Name', field: 'Customer_Name', resizable: true, sortable: true, filter: true,checkboxSelection: true,headerCheckboxSelection: true,},
    {headerName: 'Bank Name', field: 'bank_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Portfolio Name', field: 'portfolio_type', resizable: true, sortable: true, filter: true},
    {headerName: 'Settlement Type', field: 'settlement_type', resizable: true, sortable: true, filter: true},
    {headerName: 'Current Total', field: 'current_total', resizable: true, sortable: true, filter: true},
    {headerName: 'Payment Date', field: 'payment_date', resizable: true, sortable: true, filter: true},
    {headerName: 'Amount', field: 'amount', resizable: true, sortable: true, filter: true},
    {headerName: 'No of Installment', field: 'no_of_installments', resizable: true, sortable: true, filter: true},
    {headerName: 'First Installment', field: 'fst_installment', resizable: true, sortable: true, filter: true},
    {headerName: 'Approval Status', field: 'approval_status', resizable: true, sortable: true, filter: true},
    {headerName: 'Details', field: 'details_notes', resizable: true, sortable: true, filter: true},
    {headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true},
    // {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    // {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true},
    {headerName: 'ID', field: '_id', width: 250, resizable: true,sortable: true, filter: true},
    {headerName: 'Passport Number', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
  ];
  
  SettlementForm: UntypedFormGroup;
  areaCodeList: any;
  bankCodeList: any;
  fieldvisitCodeList: any;
  mStatusList: any;
  sStatusList: any;
  SettlementList = [];
  login_Details: any;
  TracingToolsList: any;
  actionstakenList: any;
  showOTSFS: boolean;
  uploaded: boolean;
  userFilter: any = { settlement_type: '' };
  LinkedAccounts: any;
  selectedAcc: string;
  blockSettlement: boolean;
  MarkCompleted_Status: boolean;
  loader_view = false;
  check_allocation_status : any;
  gridColumnApi: any;
  createdId: any;
  fintId: any;
  coordinator: any;
  customer_name: any;
  portfolio_type: any;
  bank_name: any;
  FV_Feedback: any;

  constructor(private formBuilder:UntypedFormBuilder, private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService, private router:Router, private dialog:MatDialog) { 
    this.SettlementForm = this.formBuilder.group({
      _id:['',Validators.required],
      account_id:['',Validators.required],
      amount:['',Validators.required],
      approval_status:['',Validators.required],
      attachment_url:[''],
      bank_id :['',Validators.required],
      bucket_id :['',Validators.required],
      client_id :['',Validators.required],
      createdby:['',Validators.required],
      creator_name:['',Validators.required],
      current_total:['',Validators.required],
      customer_id:['',Validators.required],
      details_notes:['',Validators.required],
      finterstal_id :['',Validators.required],
      fst_installment:[''],
      no_of_installments:[''],
      passport_no :['',Validators.required],
      payment_date:['',Validators.required],
      portfolio_id :['',Validators.required],
      product_id :['',Validators.required],
      settlement_type:['',Validators.required],
      reportingto_id:['',Validators.required],
      bank_name: ['', Validators.required],
      portfolio_type: ['', Validators.required],
      customer_name: ['', Validators.required],
    })
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridColumnApi = params.columnApi;
  }
  // addRowToTop(row: any) {
  //   const currentData = this.gridApi.getRowData();
  //   const newData = [row, ...currentData];
  //   this.gridApi.updateRowData({ add: newData });
  // }
  
  onGetSelectedRowId() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0) {
      const selectedData = selectedNodes[0].data;
      this.createdId = selectedData.createdby;
      this.fintId = selectedData.finterstal_id;
      this.coordinator = selectedData.assigned_coordinator;
      this.customer_name = selectedData.Customer_Name;
      this.portfolio_type = selectedData.portfolio_type;
      this.bank_name = selectedData.bank_name;
      this.FV_Feedback = selectedData.FV_Feedback;
     
      console.log('createdId row ID:', selectedData);
    }
  }


  ngOnInit(): void {
    this._api.setSETPAY(null);

    const LinkedData = {
      bucket_id: localStorage.getItem("Bucket_ID"),
      passport_no : localStorage.getItem("Passport_Number")

    }
    this._api.getLinkedaccounts(LinkedData).subscribe(data=>{
      if (data['Code']==200) {
        this.LinkedAccounts = data['Data'];
      } else {
        this.LinkedAccounts = [];
      }
    });

    if (localStorage.getItem('MarkCompleted') == 'true') {
      this.MarkCompleted_Status = true;
    } else {
      this.MarkCompleted_Status = false;
    }

    this.selectedAcc = localStorage.getItem("Account_ID");
    this.blockSettlement = false;
    this.login_Details = this.getFromLocal("login_Details");
    this.SettlementForm.patchValue({
      createdby: this.login_Details._id,
      creator_name: this.login_Details.name,
      customer_id: localStorage.getItem("Fintrestle_ID"),
      account_id:localStorage.getItem("Account_ID"),
      client_id : localStorage.getItem("Client_ID"),
      bank_id : localStorage.getItem("Bank_ID"),
      product_id : localStorage.getItem("Product_ID"),
      portfolio_id : localStorage.getItem("Portfolio_ID"),
      bucket_id : localStorage.getItem("Bucket_ID"),
      finterstal_id : localStorage.getItem("Fintrestle_ID"),
      passport_no : localStorage.getItem("Passport_Number"),
    })
    this._api.getlist_new_settlement(localStorage.getItem("Fintrestle_ID")).subscribe(data=>{
      if (data['Code']==200) {
        this.SettlementList = data['Data'];
        this.SettlementForm.patchValue({
          portfolio_type: data['Data'][0].portfolio_type,
          customer_name: data['Data'][0],
          bank_name : data['Data'][0].bank_name
          
        });
        this.SettlementList.forEach(element => {
          let name = JSON.parse(element.customer_name.customer_details[0],);
          element.agent_name = name[0].AGENT;
          element.Customer_Name = name[0].Customer_Name;
        });
        
        console.log(this.SettlementList,"this.SettlementList");
        
      } else {
        this.SettlementList = null;
      }
    });
    this._api.findReportTo(this.login_Details._id).subscribe(data=>{
      if (data['Code'] == 200) {
        if (data['Data'][0].member_reporting_to_id._id != null || data['Data'][0].member_reporting_to_id._id != undefined) {
          this.blockSettlement = false;
          this.SettlementForm.patchValue({
            reportingto_id: data['Data'][0].member_reporting_to_id._id
          });
        } else {
          this.blockSettlement = true;
        }
        
      } else {
        this.blockSettlement = true;
        this.SettlementForm.patchValue({
          reportingto_id: ""
        });
      }
    });


    let logindetail = this.getFromLocal("login_Details");
    console.log(logindetail);
    let values = {
      "finterstal_id":localStorage.getItem("Fintrestle_ID"),
      "assigned_to":logindetail._id
    }
    console.log(values);
    this._api.check_allocation_status(values).subscribe(data=>{
      if (data['Code']==200) {
        let check_allocation = data['Data'];
        console.log(check_allocation);
        if(check_allocation == null){
         this.check_allocation_status = false;
        }else{
          this.check_allocation_status = true;
        }
        console.log(this.check_allocation_status);
      } else {
      }
    });



  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  getFile(event){
    this.uploaded = false;
    const File = event.target.files[0];
    console.log(File);
    this._api.uploadFile(File).subscribe(data=>{
      if (data['Code'] = 200) {
        this.SettlementForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = true;
      } else {
        this.SettlementForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = false;
      }
    })
  }

  addNewSettlement(){

    if(this.check_allocation_status == false){
      alert("You don't have the access");   
      } else
      {

    this.loader_view = true;
    this.SettlementForm.patchValue({
      _id:""+new Date().getTime(),
      amount : ""+this.SettlementForm.value.amount,
      current_total : ""+this.SettlementForm.value.current_total,
    });
    console.log(this.SettlementForm.value);
    console.log(this.SettlementForm.valid);
    if(this.SettlementForm.value.reportingto_id == undefined){
      this.SettlementForm.value.reportingto_id = ''
    }
    // if (this.SettlementForm.valid) {
      this._api.create_new_settlement(this.SettlementForm.value).subscribe(data=>{
        if (data['Code'] == 200) {
          this.onPagereload();
          
          alert(data['Message']);
          
          this.sendNotification(this.SettlementForm.value);
        } else {
          alert(data['Message']);
        }
        this.loader_view = false;
      });
    // } else {
    //   console.log(this.SettlementForm.value);
      
    //   alert('Form No Valid');
    // }
      }
  }

  sendNotification(data){
    console.log("data1",data);
    // debugger
        const dataFormat = {
          from:  this.login_Details._id,
          to: data.reportingto_id,
          title: "New Notification",
          content: "You have recieved a settlement request",
          FintId: data.finterstal_id,
          Bank_Name: data.bank_name,
          Portfolio_Name: data.portfolio_type,
          Customer_Name:data.customer_name.Customer_Name,
          link : "/admin_panel/allocation/set-approval-request",
          read : false,
          status: true,
          view :true   
        }
        console.log("dataFormat",dataFormat);
        
        this._api.create_notifications(dataFormat).subscribe(data=>{
          if (data['Code'] == 200) {
            console.log("Sent",data);
    
          } else {
            console.log("Failed");
          }
        });
      }

  onPagereload(){
      this._api.getlist_new_settlement(localStorage.getItem("Fintrestle_ID")).subscribe(data=>{
        if (data['Code']==200) {
          this.SettlementList = data['Data'];
          this.SettlementList.forEach(element => {
            let name = JSON.parse(element.customer_name.customer_details[0],);
            element.agent_name = name[0].AGENT;
            element.Customer_Name = name[0].Customer_Name;
          });
        console.log(this.SettlementList,"this.SettlementList1");
        } else {
          this.SettlementList = null;
        }
      });
  }

  getSettlementType(event){
    if (event.target.value == "MTS") {
      this.showOTSFS = true;
    } else {
      this.showOTSFS = false;
    }
  }

  onTypeChange(event){
    this.userFilter.settlement_type = event.target.value;
  }

  openPayment(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1 && (selectedData[0].approval_status == 'approval' || selectedData[0].approval_status == 'Approval')) {
      this._api.setSETPAY(selectedData[0]);
      const dialogRef = this.dialog.open(UserNewPaymentComponent, {
        height: '650px',
        width:'90%',disableClose: true
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    } else {
      alert("Not Approved");
    }
  }

  viewPayment(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data );
    if (selectedData.length == 1) {
      this._api.setSETPAY(selectedData[0]);
      const dialogRef = this.dialog.open(ViewSettlementPaymentsComponent, {
        height: '650px',
        width:'90%',disableClose: true
      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    } else {
      alert("Not Approved");
    }
  }
}
